module.exports = __webpack_public_path__ + "img/icon-chat.31f14287.svg";